import { SECTOR_CODE, SERVICES_URL_MICRO } from "../../config/config"

const getListCarrers = async ({ token, callbacks, params }) => {
    let data
    // example http://localhost:8080/v1/
    if(SECTOR_CODE){
        // idSector en la URL y el array tipoCarrera en el body
        const url=SERVICES_URL_MICRO.CARRERS.SECTOR +`${SECTOR_CODE}`
        // const url='http://localhost:8081/v1/sectores/' +`${SECTOR_CODE}`
        const tipoCarrera = ['Curso','Grado']
        console.log('url',url)
        // fetch no admite body en GET, se usa XMLHttpRequest
        data = await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest()
            xhr.open('GET', url)
            xhr.setRequestHeader('Content-Type', 'application/json')
            xhr.onload = () => resolve(JSON.parse(xhr.responseText))
            xhr.onerror = () => reject(new Error('Network error'))
            xhr.send(JSON.stringify({ tipoCarrera }))
        })
    }else{
        const url=SERVICES_URL_MICRO.CARRERS.LIST + params.tipoEstudio + `?output=lovs`
        console.log('url',url)
        const res = await fetch(url)
        data = await res.json();
    }
    if (typeof callbacks === "function") {
        callbacks(data);
    }
}

export default getListCarrers;


